// @ts-nocheck

const SMARTCART_READY_TIMEOUT_MS = 12000;

function waitForSmartCartReady() {
  return new Promise((resolve) => {
    const start = Date.now();

    const isReady = () =>
      typeof window.Rebuy === 'object' &&
      window.Rebuy &&
      window.Rebuy.SmartCart &&
      window.Rebuy.SmartCart.status === 'ready';

    if (isReady()) {
      resolve(true);
      return;
    }

    let timer = null;

    const cleanup = () => {
      if (timer != null) window.clearInterval(timer);
      document.removeEventListener('rebuy:smartcart.ready', onReady);
    };

    const onReady = () => {
      cleanup();
      resolve(true);
    };

    document.addEventListener('rebuy:smartcart.ready', onReady, { once: true });

    timer = window.setInterval(() => {
      if (isReady()) {
        cleanup();
        resolve(true);
        return;
      }
      if (Date.now() - start > SMARTCART_READY_TIMEOUT_MS) {
        cleanup();
        resolve(false);
      }
    }, 50);
  });
}

async function showSmartCart() {
  const ready = await waitForSmartCartReady();
  if (!ready) return;

  try {
    window.Rebuy.SmartCart.show();
  } catch {
    /* ignore */
  }
}

function boot() {
  document.querySelectorAll('[data-ivvi-smartcart-trigger]').forEach((el) => {
    if (!(el instanceof HTMLElement)) return;
    if (el.dataset.ivviSmartcartBound === '1') return;
    el.dataset.ivviSmartcartBound = '1';

    el.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      showSmartCart();
    });

    el.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      event.stopPropagation();
      showSmartCart();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
